export default __webpack_public_path__ + "static/media/daihatsu.042d485c.png";